import {ChangeDetectorRef, Component, OnInit,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {Router} from '@angular/router';
import {CmsFlexComponentData} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {DcpBaseStoreModel} from '@app/model/dcp-config-service/basestores-country.model';
import {BaseStoreService} from '@app/services/base-store.service';
import {ForbiddenWordService} from '@app/services/user-registration/forbidden-word.service';
import {ProductDetailsPageHistoryService} from '@app/services/user-registration/product-details-page-history.service';
import {UserNameValidationService} from '@app/services/user-registration/user-name-validation.service';
import {UserRegistrationConfigService} from '@app/services/user-registration/user-registration-config.service';
import {DcpUserService} from '@app/services/user/dcp-user.service';
import {JsonService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CmsService, TranslationService, TranslatePipe} from '@spartacus/core';
import {LAUNCH_CALLER, LaunchDialogService} from '@spartacus/storefront';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {Observable, Subscription} from 'rxjs';
import {filter, switchMap, take} from 'rxjs/operators';
import {CustomerNameComponent} from '../../registration/customer-name/customer-name.component';
import {AsyncPipe} from '@angular/common';

export class SelectionB2BCmsData {
  b2b: SelectionB2BUrl;
  b2i: SelectionB2BUrl;
}

export class SelectionB2BUrl {
  link: string;
  title: string;
}

@UntilDestroy()
@Component({
  selector: 'dcp-select-type',
  templateUrl: 'select-type.component.html',
  styleUrls: ['select-type.component.scss'],
  imports: [CustomerNameComponent, AsyncPipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelectionTypeB2BComponent implements OnInit {
  componentData$: Observable<CmsFlexComponentData>;
  componentDataSubscription: Subscription = Subscription.EMPTY;
  cmsComponentId: string = 'SelectionTypeB2BComponent';
  cmsSelectionData: SelectionB2BCmsData;
  baseStore$: Observable<DcpBaseStoreModel>;
  showCustomerInfoComponent = false;
  urlToProceed: string;
  availableRegistrationFlows = [];
  quickFlow = false;
  hideForm = false;

  constructor(
    private cmsService: CmsService,
    private jsonService: JsonService,
    private router: Router,
    private productDetailsPageHistory: ProductDetailsPageHistoryService,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService,
    private userNameValidationService: UserNameValidationService,
    private userRegistrationConfigService: UserRegistrationConfigService,
    private baseStoreService: BaseStoreService,
    private launchDialogService: LaunchDialogService,
    private forbiddenWordService: ForbiddenWordService,
    private userService: DcpUserService,
    private userAccountFacade: UserAccountFacade,
  ) {}

  ngOnInit() {
    this.mapComponentData();
    this.baseStore$ = this.baseStoreService.getCurrentBaseStore();
    this.prepareAvailableRegistrationFlows();
    this.proceedIfOnlyOneValidFlow();
  }

  prepareAvailableRegistrationFlows(): void {
    const currentFlows = this.userRegistrationConfigService.getCurrent();
    if (currentFlows?.length) {
      this.availableRegistrationFlows = this.userRegistrationConfigService.getCurrent()?.split(',') || [];
    }
    this.hideForm = this.availableRegistrationFlows.length === 1;
  }

  goToNextStep(url: string): void {
    this.userNameValidationService.reset();
    this.forbiddenWordService
      .loaded()
      .pipe(
        filter(Boolean),
        switchMap((_) => this.userAccountFacade.get()),
        take(1),
        untilDestroyed(this),
      )
      .subscribe((user) => {
        if (this.userNameValidationService.getValidUserName() || this.userService.isAutoBpCreationEligibleUser(user)) {
          this.router.navigate([url], {
            queryParams: {
              fastTrack: this.availableRegistrationFlows.length === 1,
            },
            replaceUrl: this.availableRegistrationFlows.length === 1,
          });
        } else {
          this.urlToProceed = url;
          this.showCustomerInfoComponent = true;
        }
      });
  }

  navigateToNextStep(e: {detail: {originalEvent: Event}}, url: string): void {
    e.detail.originalEvent.preventDefault();
    this.goToNextStep(url);
  }

  /**
   * proceed to url if username has been validated
   * otherwise display b2b/b2i selection again
   *
   * @param validated
   */
  nameValidated(validated: boolean) {
    if (validated) {
      this.router.navigate([this.urlToProceed]);
    } else {
      this.showCustomerInfoComponent = false;
    }
  }

  isCcAllowedForCountry(baseStore: DcpBaseStoreModel) {
    return this.baseStoreService.isCcAllowedForCountry(baseStore);
  }

  openNoCcModal(): void {
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER['CC_RESTRICTED'] || 'CC_RESTRICTED');
    this.cdr.detectChanges();
  }

  onCloseModal(): void {
    this.launchDialogService.closeDialog('select-type on close');
    this.cdr.detectChanges();
  }

  backToPdp(): void {
    this.router.navigateByUrl(this.productDetailsPageHistory.getCurrent() || '/');
  }

  mapComponentData() {
    this.componentData$ = this.cmsService.getComponentData(this.cmsComponentId);
    this.componentDataSubscription = this.componentData$.pipe(untilDestroyed(this)).subscribe((data) => {
      this.cmsSelectionData = this.jsonService.parseSafely(data?.classificationsProductData);
      this.translationService
        .translate('registration.headingSelectCompany')
        .pipe(untilDestroyed(this))
        .subscribe((text) => {
          this.cmsSelectionData.b2b.title = text;
        });
      this.cmsSelectionData.b2b.link = '/b2b-company-selection';
      this.proceedIfOnlyOneValidFlow();
    });
  }

  proceedIfOnlyOneValidFlow(): void {
    if (
      !this.quickFlow &&
      this.availableRegistrationFlows.length === 1 &&
      this.cmsSelectionData[this.availableRegistrationFlows[0]]
    ) {
      this.quickFlow = true;
      this.goToNextStep(this.cmsSelectionData[this.availableRegistrationFlows[0]].link);
    }
  }
}
